/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Gettingstarted_Item11Inputs */

const he_help_gettingstarted_item11 = /** @type {(inputs: Help_Gettingstarted_Item11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הגדירו את הגדרות הארגון שלכם`)
};

const en_help_gettingstarted_item11 = /** @type {(inputs: Help_Gettingstarted_Item11Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Configure your organization settings`)
};

/**
* | output |
* | --- |
* | "Configure your organization settings" |
*
* @param {Help_Gettingstarted_Item11Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const help_gettingstarted_item11 = /** @type {((inputs?: Help_Gettingstarted_Item11Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Gettingstarted_Item11Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_help_gettingstarted_item11(inputs)
	return en_help_gettingstarted_item11(inputs)
});
export { help_gettingstarted_item11 as "help_gettingStarted_item1" }